/* Boost V2 — sitewide live presence.  v1.0.0 — 21 May 2026.
   Shows a REAL count of people currently on Boost, via Supabase Realtime PRESENCE
   on a public channel `boost:store`. Displays ONLY when the real count >= MIN
   (default 3) — never a fake/random number. Auto-clears when a tab closes.
   The supabase-js lib is loaded lazily on idle so it never blocks page render.
   Truthfulness is non-negotiable: the number shown is the real concurrent count. */
(function () {
  'use strict';
  var SUPABASE_URL = 'https://zpefopnpabbgvldtvpka.supabase.co';
  var ANON_KEY = 'sb_publishable_CWjaAfrZ0ZxVNMBwQBMQVA_rRxwkCiH';

  var root = document.querySelector('[data-boost-store-presence]');
  if (!root) return;

  var MIN = parseInt(root.getAttribute('data-min') || '3', 10);
  if (!(MIN >= 2)) MIN = 3;                       /* never show a lonely 1 */
  var verb = (root.getAttribute('data-verb') || 'browsing').trim();
  var src = root.getAttribute('data-sb-src');
  var tabId = 's_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  var shown = 0;
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tween(el, from, to, dur) {
    if (prefersReduced || from === to) { el.textContent = String(to); return; }
    var start = 0;
    function step(now) {
      if (!start) start = now;
      var t = Math.min(1, (now - start) / dur);
      var e = 1 - Math.pow(1 - t, 3);
      el.textContent = String(Math.round(from + (to - from) * e));
      if (t < 1) requestAnimationFrame(step); else el.textContent = String(to);
    }
    requestAnimationFrame(step);
  }

  function render(count) {
    if (count >= MIN) {
      var numEl = root.querySelector('[data-bsp-count]');
      if (!numEl) {
        root.innerHTML = '<span class="bsp-dot" aria-hidden="true"></span><b data-bsp-count>' + count +
          '</b> people ' + verb + ' Boost right now';
        shown = count;
      } else {
        tween(numEl, shown, count, 600);
        shown = count;
      }
      root.removeAttribute('hidden');
    } else {
      root.setAttribute('hidden', '');
    }
  }

  function loadLib(s) {
    return new Promise(function (resolve, reject) {
      if (window.supabase && window.supabase.createClient) return resolve(window.supabase);
      if (!s) return reject(new Error('no lib src'));
      var sc = document.createElement('script');
      sc.src = s; sc.async = true;
      sc.onload = function () {
        if (window.supabase && window.supabase.createClient) resolve(window.supabase);
        else reject(new Error('supabase global missing'));
      };
      sc.onerror = function () { reject(new Error('lib load failed')); };
      document.head.appendChild(sc);
    });
  }

  function init() {
    loadLib(src).then(function (lib) {
      var sb = lib.createClient(SUPABASE_URL, ANON_KEY);
      var ch = sb.channel('boost:store', { config: { presence: { key: tabId } } });
      function sync() { render(Object.keys(ch.presenceState()).length); }
      ch.on('presence', { event: 'sync' }, sync)
        .on('presence', { event: 'join' }, sync)
        .on('presence', { event: 'leave' }, sync)
        .subscribe(function (status) { if (status === 'SUBSCRIBED') { ch.track({ at: Date.now() }); } });
      function cleanup() {
        try { ch.untrack(); } catch (e) {}
        try { sb.removeChannel(ch); } catch (e) {}
      }
      window.addEventListener('pagehide', cleanup);
      window.addEventListener('beforeunload', cleanup);
    }).catch(function () { /* presence unavailable — line just stays hidden */ });
  }

  /* Defer to idle so the live lib never blocks first paint on any page. */
  if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 2500 });
  else setTimeout(init, 1200);
})();
